import React from "react";
import {Container} from "@/shared/components/shared";
import Image from "next/image";


export const FiveFacts: React.FC = () => {
    return (
        <>
            <section className={'bg-custom-black'}>
                <Container className={'pt-14 lg:pt-29 pb-8 lg:pb-43'}>
                    <div>
                        <h2 className={'text-custom-orange uppercase text-[30px] lg:text-[70px] font-bold leading-[1.2]'}>5
                            фактов о
                            f1</h2>
                        <p className={'text-white uppercase text-[24px] lg:text-[45px] leading-[1.2] mt-7'}>
                            результаты<br className={'lg:hidden'}/> убедительнее слов
                        </p>
                    </div>
                    <div className="grid grid-cols-2 lg:grid-cols-5 gap-0 mt-8 lg:mt-27">
                        <div
                            className={'order-1 lg:order-none flex items-center justify-center border-b-1 border-r-1 border-custom-light-gray pl-12 pr-12 pb-4 lg:pt-2 lg:pb-11 lg:pl-0 lg:pr-0'}>
                            <Image src={'/images/five-facts/people.svg'} width={163} height={205} alt={"клиенты"}/>
                        </div>
                        <div
                            className={'order-3 lg:order-none flex items-center justify-center border-b-1 border-r-1 border-custom-light-gray pl-10 pr-10 pb-4 pt-4 pb-7 lg:pt-2 lg:pb-11'}>
                            <Image src={'/images/five-facts/car.svg'} width={236} height={154} alt={"машина"}/>
                        </div>
                        <div
                            className={'order-5 lg:order-none flex items-center justify-center border-b-1 border-r-1 border-custom-light-gray pl-10 pr-10 pb-4 pt-4 lg:pt-2 lg:pb-11'}>
                            <Image src={'/images/five-facts/12year.svg'} width={193} height={190}
                                   alt={"12 лет работы"}/>
                        </div>
                        <div
                            className={'order-7 lg:order-none flex items-center justify-center border-b-1 border-r-1 border-custom-light-gray pl-10 pr-10 pb-4 pt-4 lg:pt-2 lg:pb-11'}>
                            <Image src={'/images/five-facts/like.svg'} width={163} height={159} alt={"отзывы"}/>
                        </div>
                        <div
                            className={'order-9 lg:order-none flex items-center justify-center border-r-1 lg:border-b-1 lg:border-r-0  border-custom-light-gray pl-10 pr-10 pb-4 pt-4 lg:pt-2 lg:pb-11'}>
                            <Image src={'/images/five-facts/storage.svg'} width={163} height={159} alt={"отзывы"}/>
                        </div>
                        <div
                            className={'order-2 lg:order-none flex justify-center items-center border-b-1 lg:border-b-0 lg:border-r-1 border-custom-light-gray pl-10 pr-1 lg:px-0 lg:pt-11 lg:pb-2'}>
                            <p className={'mt-auto mb-auto text-white text-[18px] lg:text-[24px] leading-[1.1] lg:leading-[1.2] uppercase lg:text-center w-full'}>
                                более 900<br/> постоянных<br/> гостей
                            </p>
                        </div>
                        <div
                            className={'order-4 lg:order-none flex justify-center items-center border-b-1 lg:border-b-0 lg:border-r-1 border-custom-light-gray pl-10 pr-1 lg:px-0 lg:pt-11 lg:pb-2'}>
                            <p className={'mt-auto mb-auto text-white text-[18px] lg:text-[24px] leading-[1.1] lg:leading-[1.2] uppercase lg:text-center w-full'}>
                                9<br/> современных<br/> постов
                            </p>
                        </div>
                        <div
                            className={'order-6 lg:order-none flex items-center justify-center border-b-1 lg:border-b-0 lg:border-r-1 border-custom-light-gray pl-10 pr-1 lg:px-0 lg:pt-11 lg:pb-2'}>
                            <p className={'mt-auto mb-auto text-white text-[18px] lg:text-[24px] leading-[1.1] lg:leading-[1.2] uppercase lg:text-center w-full'}>
                                12+ опыт мастеров<br/> и экспертов
                            </p>
                        </div>
                        <div
                            className={'order-8 lg:order-none flex items-center justify-center border-b-1 lg:border-b-0 lg:border-r-1 border-custom-light-gray pl-10 pr-1 lg:pt-11 lg:px-0'}>
                            <p className={'mt-auto mb-auto text-white text-[18px] lg:text-[24px] leading-[1.1] lg:leading-[1.2] uppercase lg:text-center w-full'}>
                                97% гостей<br/> довольны нашей работой
                            </p>
                        </div>
                        <div
                            className={'order-10 lg:order-none flex items-center justify-center pl-10 pr-1 lg:pt-11 lg:px-0'}>
                            <p className={'mt-auto mb-auto text-white text-[18px] lg:text-[24px] leading-[1.1] lg:leading-[1.2] uppercase lg:text-center w-full'}>
                                Собственный склад запчастей
                            </p>
                        </div>
                    </div>
                </Container>
            </section>
            <section className={'bg-custom-dark-gray'}>
                <Container className={'pt-8 pb-8 lg:pt-12 lg:pb-12'}>
                    <h2 className={'text-white uppercase text-[18px] lg:text-[45px] leading-[1.2]'}>Защита от подделок и
                        гарантия<br/>на все работы и материалы</h2>
                </Container>
            </section>
        </>
    );
};